import React, { SyntheticEvent } from "react";
import { FieldText, FieldSelect } from "@conserveit/blocks";
import { MsgAlert } from "..";
import { Hr, Container } from "./UserForm.styles";

interface Option {
  label: string;
  value: string | number;
}
interface Props {
  error: [];
  formData: {
    [key: string]: any;
  };
  onChange: (
    e?: SyntheticEvent<HTMLInputElement, Event> | Option["value"],
    inputId?: string
  ) => void;
  rolesSelectOptions: Option[];
  groupOptions: Option[];
}

const CreateUserForm: React.FC<Props> = ({
  error,
  formData,
  onChange,
  rolesSelectOptions,
  groupOptions,
}) => {
  const formatGroup = (selectedGroup: Option[]) =>
    selectedGroup.map(({ value }) => value).join(",");
  const formatRole = (selectedRole: Option) => selectedRole.value;

  return (
    <Container>
      <MsgAlert type="error" message={error} />
      <FieldText
        name="user_email"
        type="email"
        label="Email"
        placeholder="Email"
        value={formData.user_email || ""}
        onChange={onChange}
      />

      <FieldText
        name="user_fullname"
        type="text"
        label="Full Name"
        placeholder="Full Name"
        value={formData.user_fullname || ""}
        onChange={onChange}
      />

      <FieldText
        name="user_username"
        type="text"
        label="Username"
        placeholder="Username"
        value={formData.user_username || ""}
        onChange={onChange}
      />

      <FieldText
        name="user_password"
        type="password"
        label="Password"
        placeholder="Password"
        value={formData.user_password || ""}
        onChange={onChange}
      />

      <FieldText
        name="user_password_confirm"
        type="password"
        label="Confirm Password"
        placeholder="Password (again)"
        value={formData.user_password_confirm || ""}
        onChange={onChange}
      />

      <Hr />

      <FieldSelect
        className="t-SelectRole"
        label="Role"
        name="user_role"
        placeholder="Select..."
        options={rolesSelectOptions}
        onChange={(value) => onChange(formatRole(value as Option), "user_role")}
        menuPosition="fixed"
      />

      <FieldSelect
        className="t-SelectGroup"
        label="Group"
        name="user_group"
        isMulti
        placeholder="Select..."
        options={groupOptions}
        onChange={(selectedItems) =>
          onChange(formatGroup(selectedItems as Option[]), "user_group")
        }
        menuPosition="fixed"
      />
    </Container>
  );
};

export default CreateUserForm;
